import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const get = async ({ contractId = '', ...params }) => {
  return await recurrenceAPI.get(`/contracts/${contractId}`, { params })
}

const create = async params => {
  return await recurrenceAPI.post('contracts/complete', params)
}

const update = async ({ contractId = '', ...data }) => {
  return await recurrenceAPI.put(`/contracts/${contractId}`, data)
}

const downloadCsv = async ({ ...params }) => {
  return await recurrenceAPI.get(`/contracts.csv/`, {
    params,
  })
}

const inactivate = async ({ contractId = '', ...params }) => {
  return await recurrenceAPI.delete(`/contracts/${contractId}`, { params })
}

const forceActivate = async ({ contractId = '' }) => {
  return await recurrenceAPI.post(`contracts/reactivate/${contractId}`)
}

const inactivateDebit = async ({ contractId = '' }) => {
  return await recurrenceAPI.put(`/contracts/${contractId}/inactivate_debit`)
}

const activePenalty = async ({ contractId }) => {
  return await recurrenceAPI.put(
    `/contracts/${contractId}/update_to_active_penalty`,
  )
}

export default {
  get,
  create,
  update,
  downloadCsv,
  inactivate,
  inactivateDebit,
  activePenalty,
  forceActivate
}
